import { defineMessages } from '../define';

/** Attendance statistics (Stjórnun → Mæting, Stillingar → Mætingin mín) and the calendar subscription. */
export const stats = defineMessages(
  {
    'stats.title': 'Mæting',
    'stats.range.label': 'Tímabil',
    'stats.range.this': 'Þetta starfsár',
    'stats.range.last': 'Síðasta starfsár',
    'stats.range.custom': 'Velja tímabil',
    'stats.range.from': 'Frá',
    'stats.range.to': 'Til',
    'stats.range.invalid': 'Upphafsdagur þarf að vera á undan lokadegi og tímabilið mest þrjú ár.',
    'stats.range.span': '{from} – {to}',
    'stats.season': 'Starfsárið {years}',
    'stats.overall': 'Meðalmæting kórsins',
    'stats.events_count': { one: '{count} viðburður talinn', other: '{count} viðburðir taldir' },
    'stats.members_count': { one: '{count} félagi', other: '{count} félagar' },
    'stats.filter_hint': 'Ýttu á rödd til að sýna aðeins hana.',
    'stats.filter_on': 'Sýni aðeins {section}',
    'stats.clear_filter': 'Sýna alla',
    'stats.members': 'Félagar',
    'stats.events': 'Viðburðir',
    'stats.sort.label': 'Raða eftir',
    'stats.sort.name': 'Nafni',
    'stats.sort.pct': 'Mætingu',
    'stats.of': '{present} af {total}',
    'stats.present': 'Mætt/ur',
    'stats.excused': 'Boðuð forföll',
    'stats.absent': 'Fjarverandi',
    'stats.total': 'Alls',
    'stats.pct': 'Mæting',
    'stats.no_pct': '–',
    'stats.overridden': 'Skráð af stjórnanda',
    'stats.empty': 'Engin mæting á þessu tímabili',
    'stats.empty_hint': 'Aðeins liðnir viðburðir sem telja til mætingar eru taldir með.',
    'stats.event.attended': '{present} af {total} mættu',
    'stats.detail.empty': 'Enginn viðburður talinn á tímabilinu.',
    'stats.how.title': 'Hvernig er mæting reiknuð?',
    'stats.how.events':
      'Taldir eru liðnir viðburðir sem telja til mætingar og voru ekki felldir niður. Hver félagi er talinn á viðburðum sem ætlaðir eru öllum kórnum eða hans rödd; stjórnandi og hljóðfæraleikarar aðeins þegar viðburðurinn er sérstaklega ætlaður þeim.',
    'stats.how.result':
      'Mætt/ur = skráði mætingu sína eða var merkt/ur mætt/ur af stjórnanda. Boðuð forföll = svaraði „Kem ekki“. Annars fjarverandi. Merking stjórnanda á mætingarlista gildir alltaf.',
    'stats.how.members': 'Félagar í leyfi eða hættir eru ekki taldir, né viðburðir áður en félagi gekk í kórinn.',
    'stats.export': 'Sækja CSV',
    'stats.export_short': 'CSV',
    'stats.export_done': 'CSV-skrá vistuð',
    'stats.csv.name': 'Nafn',
    'stats.csv.section': 'Rödd',
    'stats.csv.pct': 'Mæting (%)',

    'stats.my.title': 'Mætingin mín',
    'stats.my.summary': { one: 'Þú mættir á {present} af {count} viðburði', other: 'Þú mættir á {present} af {count} viðburðum' },
    'stats.my.show_list': 'Sjá viðburðina',
    'stats.my.list_title': 'Mætingin mín {years}',

    'stats.feed.title': 'Dagatal í símann',
    'stats.feed.intro': 'Fáðu æfingar og tónleika sjálfkrafa í dagatalið í símanum.',
    'stats.feed.create': 'Búa til áskriftarhlekk',
    'stats.feed.your_link': 'Áskriftarhlekkurinn þinn',
    'stats.feed.link_label': 'Áskriftarhlekkur',
    'stats.feed.open': 'Opna í dagatali',
    'stats.feed.shown_once': 'Hlekkurinn er aðeins sýndur núna. Hann er persónulegur – deildu honum bara í þín eigin tæki.',
    'stats.feed.google': 'Google dagatal: afritaðu hlekkinn og veldu „Bæta við dagatali“ → „Frá vefslóð“ á calendar.google.com.',
    'stats.feed.active': 'Áskrift er virk',
    'stats.feed.active_hint': 'Til að bæta dagatalinu við annað tæki þarftu nýjan hlekk. Sá gamli hættir þá að virka.',
    'stats.feed.rotate': 'Búa til nýjan hlekk',
    'stats.feed.rotate_confirm': 'Búa til nýjan hlekk?',
    'stats.feed.rotate_body': 'Gamli hlekkurinn hættir að virka og dagatöl sem nota hann hætta að uppfærast.',
    'stats.feed.stop': 'Hætta áskrift',
    'stats.feed.stop_confirm': 'Hætta áskrift?',
    'stats.feed.stop_body': 'Hlekkurinn hættir að virka. Fjarlægðu líka dagatalið úr dagatalsforritinu svo viðburðirnir hverfi.',
    'stats.feed.stopped': 'Áskrift stöðvuð',
    'stats.feed.refresh_note': 'Dagatöl í áskrift uppfærast á nokkurra klukkustunda fresti, svo breytingar geta birst seint.',
    'stats.feed.privacy_note': 'Dagatalsforritið (t.d. frá Apple eða Google) fær upplýsingar um viðburðina: heiti, tíma, staðsetningu, lýsingu og þitt svar.',
    'stats.feed.copy_failed': 'Tókst ekki að afrita – veldu hlekkinn og afritaðu hann handvirkt.',
    'stats.feed.needs_online': 'Tengstu netinu til að stjórna áskriftinni.',
  },
  {
    'stats.title': 'Attendance',
    'stats.range.label': 'Period',
    'stats.range.this': 'This season',
    'stats.range.last': 'Last season',
    'stats.range.custom': 'Choose period',
    'stats.range.from': 'From',
    'stats.range.to': 'To',
    'stats.range.invalid': 'The start date must be before the end date, and the period at most three years.',
    'stats.range.span': '{from} – {to}',
    'stats.season': 'Season {years}',
    'stats.overall': 'Choir average',
    'stats.events_count': { one: '{count} event counted', other: '{count} events counted' },
    'stats.members_count': { one: '{count} member', other: '{count} members' },
    'stats.filter_hint': 'Tap a section to show only that section.',
    'stats.filter_on': 'Showing only {section}',
    'stats.clear_filter': 'Show all',
    'stats.members': 'Members',
    'stats.events': 'Events',
    'stats.sort.label': 'Sort by',
    'stats.sort.name': 'Name',
    'stats.sort.pct': 'Attendance',
    'stats.of': '{present} of {total}',
    'stats.present': 'Present',
    'stats.excused': 'Excused',
    'stats.absent': 'Absent',
    'stats.total': 'Total',
    'stats.pct': 'Attendance',
    'stats.no_pct': '–',
    'stats.overridden': 'Set by the conductor',
    'stats.empty': 'No attendance in this period',
    'stats.empty_hint': 'Only past events that count towards attendance are included.',
    'stats.event.attended': '{present} of {total} attended',
    'stats.detail.empty': 'No counted events in this period.',
    'stats.how.title': 'How is attendance calculated?',
    'stats.how.events':
      'Past events that count towards attendance and were not cancelled. Each member is counted for events aimed at the whole choir or their section; the conductor and musicians only when the event is aimed at them explicitly.',
    'stats.how.result':
      'Present = checked in or marked present by the conductor. Excused = answered “Not coming”. Otherwise absent. The conductor’s mark on the roster always wins.',
    'stats.how.members': 'Members on leave or who have left are not counted, nor events before a member joined.',
    'stats.export': 'Download CSV',
    'stats.export_short': 'CSV',
    'stats.export_done': 'CSV file saved',
    'stats.csv.name': 'Name',
    'stats.csv.section': 'Section',
    'stats.csv.pct': 'Attendance (%)',

    'stats.my.title': 'My attendance',
    'stats.my.summary': { one: 'You attended {present} of {count} event', other: 'You attended {present} of {count} events' },
    'stats.my.show_list': 'See the events',
    'stats.my.list_title': 'My attendance {years}',

    'stats.feed.title': 'Calendar on your phone',
    'stats.feed.intro': 'Get rehearsals and concerts into the calendar on your phone automatically.',
    'stats.feed.create': 'Create subscription link',
    'stats.feed.your_link': 'Your subscription link',
    'stats.feed.link_label': 'Subscription link',
    'stats.feed.open': 'Open in Calendar',
    'stats.feed.shown_once': 'The link is only shown now. It is personal – only share it with your own devices.',
    'stats.feed.google': 'Google Calendar: copy the link and choose “Add calendar” → “From URL” on calendar.google.com.',
    'stats.feed.active': 'Subscription is active',
    'stats.feed.active_hint': 'To add the calendar to another device you need a new link. The old one then stops working.',
    'stats.feed.rotate': 'Create a new link',
    'stats.feed.rotate_confirm': 'Create a new link?',
    'stats.feed.rotate_body': 'The old link stops working and calendars that use it stop updating.',
    'stats.feed.stop': 'Stop subscription',
    'stats.feed.stop_confirm': 'Stop the subscription?',
    'stats.feed.stop_body': 'The link stops working. Also remove the calendar from your calendar app so the events disappear.',
    'stats.feed.stopped': 'Subscription stopped',
    'stats.feed.refresh_note': 'Subscribed calendars refresh every few hours, so changes may show up late.',
    'stats.feed.privacy_note': 'Your calendar app (e.g. from Apple or Google) receives the event data: title, time, location, description and your reply.',
    'stats.feed.copy_failed': 'Could not copy – select the link and copy it manually.',
    'stats.feed.needs_online': 'Connect to the internet to manage the subscription.',
  },
);
